<div class="config-loading" *ngIf="!loaded">
    <div class="k-i-loading"></div>
</div>

<section class="config-section" *ngIf="loaded">
    <h3 class="config-section-title">
        System Configuration
        <span class="config-counter" *ngIf="!searching">{{ keyCount }} settings</span>
        <span class="config-counter" *ngIf="searching">{{ visibleCount }} of {{ keyCount }} settings</span>
    </h3>

    <p class="config-counter config-note">
        Read-only view of this tenant's installed settings file, as the overnight run reads it.
        Credential values are masked by the API and are never sent to the browser.
    </p>

    <div class="config-setting">
        <label class="config-label">Search</label>
        <kendo-textbox class="config-control"
                       placeholder="Filter by setting or group"
                       [value]="searchTerm"
                       (valueChange)="handleSearch($event)"></kendo-textbox>
    </div>

    <!-- scrollable="none" renders every row in flow and lets this wrapper scroll. ~250
         read-only rows do not need virtualization, and it avoids having to give the grid
         a fixed height inside a mat-tab body. -->
    <div class="settings-grid-wrap" #gridWrap [style.maxHeight.px]="gridMaxHeight">
        <kendo-grid [data]="gridData"
                    [group]="groups"
                    [groupable]="false"
                    [scrollable]="'none'">
            <kendo-grid-column field="key" title="Setting" [headerClass]="'ra-grid-header'" [width]="400">
            </kendo-grid-column>

            <kendo-grid-column field="type" title="Type" [headerClass]="'ra-grid-header'" [width]="110">
            </kendo-grid-column>

            <kendo-grid-column field="value" title="Value" [headerClass]="'ra-grid-header'" [width]="480">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="isRedacted(dataItem)" class="settings-redacted" kendoTooltip
                          title="Masked by the API because the setting name looks credential-bearing.">
                        <mat-icon class="settings-lock-icon">lock</mat-icon>{{ displayValue(dataItem) }}
                    </span>
                    <span *ngIf="!isRedacted(dataItem)">{{ displayValue(dataItem) }}</span>
                </ng-template>
            </kendo-grid-column>

            <ng-template kendoGridDetailTemplate let-dataItem
                         [kendoGridDetailTemplateShowIf]="isNested">
                <pre class="settings-json">{{ dataItem.value | json }}</pre>
            </ng-template>
        </kendo-grid>
    </div>

    <p class="config-counter config-note" *ngIf="!keyCount">
        No settings were returned for this tenant.
    </p>
</section>
